import { logger } from '@/features/notifications/logger'
import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { listenFirebaseRecentNotification } from '@/features/notifications/utils/listenFirebaseRecentNotification'
import { isSoundEnabled, playNotificationSound } from '@/features/notifications/utils/soundHelpers'
import { appToFirebaseType } from '@/features/notifications/utils/transforms'
import { useEffect, useState } from 'react'

export const useHeaderNotification = (
    disableListener: boolean
): [Notification | undefined, () => void] => {
    const [notification, setNotification] = useState<Notification>()

    useEffect(() => {
        if (disableListener) return

        return listenFirebaseRecentNotification(async (notification) => {
            setNotification(notification)

            const isSound = await isSoundEnabled(appToFirebaseType(notification.type))

            if (isSound) {
                try {
                    await playNotificationSound()
                } catch (error) {
                    logger.errorOnly(error)
                }
            }
        })
    }, [disableListener])

    const clear = () => setNotification(undefined)

    return [notification, clear]
}
